<template>
    <cart-widget-toggle-base>
        <template slot-scope="{ count, toggle }">
            <span class="menuitem menuitem-cart flex" id="cart-widget">
                <a
                    :href="url"
                    @click="toggle"
                   class="button-cart">
                    <span class="button-cart-quantity">
                        <span>{{ count }}</span>
                        </span>
                            <svg class="icon" :aria-label="__('Kosár')">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-cart"></use>
                    </svg>
                </a>
            </span>
        </template>
        <cart-widget-toggle-base/>
    </cart-widget-toggle-base>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            required: true
        }
    }
}
</script>
